import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  image: {
    display: 'block',
    height: 32,
    objectFit: 'contain',
    width: 32,
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <img
      alt="Cedarwell"
      className={classes.image}
      src="/assets/brand/backstage/sidebar-icon.png"
    />
  );
};
